/**
 * 联采严选前端总开关（默认关闭）。
 *
 * - 构建时注入 `REACT_APP_YANXUAN_ENABLED=true` 才会启用严选入口：
 *   采购端默认严选工作台（顶栏可进自选直采看历史订单）、平台端严选菜单、`/yanxuan*` 路由、`/yanxuan/login`、
 *   指定严选供应商登录时的 capability 探测与「选择工作台」弹窗、严选徽标请求与预取。
 * - 关闭时上述入口全部隐藏 / 重定向，行为与 1.0 现网一致；作为上线后的第一道回滚手段。
 * - 本地严选开发由 `start-yanxuan-frontend.sh` / `.env.yanxuan` 注入 true；生产 `.env.production` 为 true（回滚改 false 重建）。
 */
export function isYanxuanEnabled(): boolean {
  return String(process.env.REACT_APP_YANXUAN_ENABLED || '').trim().toLowerCase() === 'true';
}

/**
 * 当前 URL 是否属于严选界面（用于仅在严选页面生效的全局补丁，如可拖拽弹窗）：
 * `/yanxuan*`、采购工作台严选通道（`?tab=yanxuan-*`）、平台端严选菜单（`?menu=yanxuan*`）。
 */
export function isYanxuanSurface(pathname: string, search = ''): boolean {
  if (!isYanxuanEnabled()) return false;
  const path = String(pathname || '');
  if (path === '/yanxuan' || path.startsWith('/yanxuan/')) return true;
  if (/\/yanxuan\/product\//.test(path)) return true;
  const params = new URLSearchParams(search || '');
  if (path.startsWith('/buyer') || path.startsWith('/central-procurement')) {
    const tab = params.get('tab') || '';
    return tab.startsWith('yanxuan-');
  }
  if (path.startsWith('/platform')) {
    return (params.get('menu') || '').startsWith('yanxuan');
  }
  return false;
}
